import React from 'react'
import {
    Box,
    Stack,
    Typography
} from '@mui/material'
import IconButton from '@mui/material/IconButton'

import data from '../../data/portfolio.json'
import './footer.css'

const Footer = () =>
    <Box
        width={{ xs: '100%' }}
        position="relative"
        bgcolor="#C9C7C6"
        px={{ xs: 3, md: 10 }}
        pt={10}
        pb={5}
    >
        <div className="custom-shape-divider-top-1712418614">
            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                <path d="M1200 120L0 16.48 0 0 1200 0 1200 120z" className="shape-fill"></path>
            </svg>
        </div>
        <Stack
            direction={{ xs: 'column', md: 'row' }}
            justifyContent="space-between"
            width={{ xs: '100%' }}
        >
            <Stack
                direction={{ xs: 'column' }}
                spacing={{ xs: 1 }}
                zIndex={100}
                alignItems='flex-start'
            >
                <IconButton
                    aria-label="Behance"
                    href={data.behance.url}
                    target='_blank'
                    sx={{
                        color: "#000000a1",
                        '&:hover': {
                            color: "#000000",
                            borderRadius: 2,
                        },
                    }}
                    title={data.behance.title}
                >
                    <Box
                        component={'img'}
                        src="https://img.icons8.com/?size=100&id=16280&format=png&color=000000f1"
                        width={{ xs: 35 }} />
                    <Typography
                        variant="span"
                        gutterBottom
                        fontFamily={"League Gothic, sans-serif"}
                        sx={{
                            mx: 1,
                            color: "#000000f1",
                            fontSize: { xs: 20 },
                        }}>
                        youssefmohammed57
                    </Typography>
                </IconButton>
                <IconButton
                    aria-label="Instagram"
                    href={data.instagram.url}
                    target='_blank'
                    sx={{
                        color: "#000000a1",
                        '&:hover': {
                            color: "#000000",
                            borderRadius: 2,
                        },
                    }}
                    title={data.instagram.title}
                >

                    <Box
                        component={'img'}
                        src="https://img.icons8.com/?size=100&id=32309&format=png&color=000000f1"
                        width={{ xs: 35 }} />
                    <Typography
                        variant="span"
                        gutterBottom
                        fontFamily={"League Gothic, sans-serif"}
                        sx={{
                            mx: 1,
                            color: "#000000f1",
                            fontSize: { xs: 20 },
                        }}>
                        Youssef_Defenshi
                    </Typography>
                </IconButton>
                <IconButton
                    aria-label="Facebook"
                    href={data.facebook.url}
                    target='_blank'
                    sx={{
                        color: "#000000a1",
                        '&:hover': {
                            color: "#000000",
                            borderRadius: 2,
                        },
                    }}
                    title={data.facebook.title}
                >

                    <Box
                        component={'img'}
                        src="https://img.icons8.com/?size=100&id=8818&format=png&color=000000f1"
                        width={{ xs: 35 }} />
                    <Typography
                        variant="span"
                        gutterBottom
                        fontFamily={"League Gothic, sans-serif"}
                        sx={{
                            mx: 1,
                            color: "#000000f1",
                            fontSize: { xs: 20 },
                        }}>
                        YOUSSEF MOHAMMED
                    </Typography>
                </IconButton>
                <IconButton
                    aria-label="Whatsapp"
                    href={data.whatsapp.url}
                    target='_blank'
                    sx={{
                        color: "#000000a1",
                        '&:hover': {
                            color: "#000000",
                            borderRadius: 2,
                        },
                    }}
                    title={data.whatsapp.title}
                >
                    <Box
                        component={'img'}
                        src="https://img.icons8.com/?size=100&id=16733&format=png&color=000000f1"
                        width={{ xs: 35 }} />
                    <Typography
                        variant="span"
                        gutterBottom
                        fontFamily={"League Gothic, sans-serif"}
                        sx={{
                            mx: 1,
                            color: "#000000f1",
                            fontSize: { xs: 20 },
                        }}>
                        +20 127 0014 050
                    </Typography>
                </IconButton>
            </Stack>
            <Stack
                pt={5}
                zIndex={100}
                sx={{
                    justifyContent: "flex-end",
                    alignItems: "center",
                }}>
                <Typography
                    variant="p"
                    gutterBottom
                    fontFamily={"League Gothic, sans-serif"}
                    fontWeight={100}
                    sx={{
                        color: "#000000f1",
                        fontSize: { xs: 18 },
                    }}>
                    Made by 💙
                    <Typography
                        variant="span"
                        gutterBottom
                        mx={0.5}
                        fontFamily={"League Gothic, sans-serif"}
                        fontWeight={100}
                        onClick={() => window.open("https://mohammed-moataz.vercel.app", "_blank")}
                        sx={{
                            cursor: "pointer",
                            color: "#123456f1",
                            fontSize: { xs: 18 },
                            "&:hover": {
                                color: "#123456",
                                textDecoration: "underline",
                            }
                        }}>
                        Mohammed Moataz
                    </Typography>
                </Typography>
            </Stack>
        </Stack>
    </Box >

export default Footer